import axios from "../axios";

//发布新版本
export const uploadNewVersion = (data) => {
    console.log(data)
    return axios({
        url: "common/upload_new_version",
        method: "post",
        data
    })
}

//获取版本列表
export const getVersionList = (data) => {
    return axios({
        url: "common/query_version_list",
        method: "post",
        data
    })
}

//修改版本信息
export const editVersionInfo = (data) => {
    return axios({
        url: "common/modify_version_info",
        method: "post",
        data
    })
}

